import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowUpRight } from 'lucide-react';
import Reveal from '../components/Reveal';
import { SERVICES, SECTORS } from '../data/mock';

export default function Services() {
  return (
    <div className="bg-[var(--bg)]">
      <section className="pt-36 pb-16 border-b border-[var(--line)]">
        <div className="container-rs">
          <span className="section-index"><span className="coral-dot" /> 002 — Services</span>
          <Reveal>
            <h1 className="font-display text-7xl md:text-[150px] leading-[0.92] mt-6">Two studios. <span className="font-display-italic text-[var(--coral)]">One standard.</span></h1>
          </Reveal>
          <div className="grid md:grid-cols-12 gap-8 mt-10">
            <p className="md:col-span-7 md:col-start-6 text-[18px] md:text-[20px] text-[var(--ink-mute)] leading-relaxed">
              Based centrally in Shropshire, we offer nationwide construction services to a host of different industry sectors as specialists in both interior fit-out and residential new build &amp; conversion. We operate as Principal Contractor and Sub-Contractor and our highly experienced team continually delivers service excellence.
            </p>
          </div>
        </div>
      </section>

      <section className="py-24">
        <div className="container-rs space-y-32">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} className="grid md:grid-cols-12 gap-10 items-center">
              <div className={`md:col-span-7 ${i % 2 === 1 ? 'md:order-2' : ''}`}>
                <div className="overflow-hidden rounded-3xl">
                  <img src={s.image} alt={s.title} className="w-full h-[460px] md:h-[640px] object-cover zoom-img" />
                </div>
              </div>
              <div className={`md:col-span-5 ${i % 2 === 1 ? 'md:order-1' : ''}`}>
                <span className="section-index"><span className="coral-dot" /> {s.code} — {s.tag}</span>
                <h2 className="font-display text-5xl md:text-7xl mt-4 leading-[0.95]">{s.title}<span className="text-[var(--coral)]">.</span></h2>
                <p className="mt-6 text-[15px] text-[var(--ink-mute)] leading-relaxed">{s.long}</p>
                <ul className="mt-8 grid sm:grid-cols-2 gap-x-6 gap-y-3">
                  {s.bullets.map((b) => (
                    <li key={b} className="flex items-start gap-3 text-[14px]"><span className="w-1.5 h-1.5 mt-2 rounded-full bg-[var(--coral)] shrink-0" />{b}</li>
                  ))}
                </ul>
                <div className="mt-10 flex gap-3 flex-wrap">
                  <Link to={`/services/${s.id}`} className="pill pill-outline-dark"><span>Explore {s.title}</span><ArrowUpRight size={14} /></Link>
                  <Link to="/contact" className="pill pill-coral"><span>Brief us</span><ArrowUpRight size={14} /></Link>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="py-20 bg-[var(--bg-soft)]">
        <div className="container-rs">
          <span className="section-index"><span className="coral-dot" /> Sectors served</span>
          <h2 className="font-display text-4xl md:text-6xl mt-6 leading-[0.95]">Across <span className="font-display-italic text-[var(--coral)]">every</span> sector.</h2>
          <div className="mt-12 flex flex-wrap gap-3">
            {SECTORS.map((s) => (
              <span key={s} className="px-6 py-4 rounded-full bg-white border border-[var(--line)] text-[14px] font-medium hover:border-[var(--coral)] hover:text-[var(--coral)] transition-colors">{s}</span>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
